import styled from "styled-components";
import { BsSearch } from "react-icons/bs";

const StyledForm = styled.form`
  display: flex;
  align-items: center;
  background-color: var(--color-grey-200);
  border-radius: 2rem;
  padding: 5px 10px;
  overflow: hidden;
  height: 3rem;
  width: 25rem;
  box-shadow: var(--box-shadow);
`;

const SearchIcon = styled(BsSearch)`
  color: var(--color-grey-900);
  font-size: 1.6rem;
`;

const StyledInput = styled.input`
  border: none;
  outline: none;
  background-color: var(--color-grey-200);
  color: var(--color-grey-900);
  padding: 0.5rem;
  margin-left: 0.5rem;
  width: 100%;

  &::placeholder {
    color: var(--color-grey-500);
    font-size: 1.4rem;
  }
`;

function Search({ onChange }) {
  return (
    <StyledForm>
      <SearchIcon />
      <StyledInput
        type="text"
        placeholder="Search a country..."
        onChange={onChange}
      />
    </StyledForm>
  );
}

export default Search;
